
import { Component, Vue } from "vue-property-decorator";
import vuetifyToast from 'vuetify-toast';
import { Passenger } from '@/components/Passenger/models/Passenger';
import { Timetable } from '@/components/Timetable/models/Timetable';
import { Utility } from '@/components/Passenger/models/Utility';
import { Ride } from '@/components/Timetable/models/Ride';
import { ArrivalDeparture } from '@/components/ArrivalsDepartures/models/ArrivalDeparture';
import { RolePermission } from '@/models/Role';
import Routes from '../../../Routes';

@Component({
    components: {
    },
  })
export class PassengerDialog extends Vue {
    static readonly EVENT_PASSENGER_DIALOG_SHOW = "EVENT_PASSENGER_DIALOG_SHOW";
    passenger: Passenger = null;
    show: boolean = false;
    timetable: Timetable = null;
    passengerTimetableRides: Ride[] = [];
    arrivalDeparture: ArrivalDeparture = null;
    sendingArrivalDepartureCancel: boolean = false;

    cancelreason: string = '';
    cancelreasonvalid: boolean = false;
    cancelreasonrules: any[] = [val => this.cancelReasonRequired(val)];

    get routeDestinationId(): number {
        return Number.parseInt(this.$store.state.route.params.destinationId, 10);
    }

    get me() {
        return this.$store.state.user.me;
    }

    get userCanEditTimetables(): boolean {
        return this.me 
            ? this.me.hasPermissions(this.routeDestinationId, [RolePermission.UpdateTimetables])
            : false;
    }

    get userCanEditPassengers(): boolean {
        return this.me 
            ? this.me.hasPermissions(this.routeDestinationId, [RolePermission.UpdatePassengers])
            : false;
    }

    utilityTitle(utilityId: number): string{
        const utility: Utility = Passenger.utilities.find((u: any) => u.id === utilityId);
        return utility 
            ? this.$i18n.translate("utility.title." + utility.title, utility.title) 
            : "Unknown utility";
    }

    utilityIconImageSrc(utilityId: number): string{
        const imageBasePath = '/frontend/utilities/';
        if (utilityId === 2){
            return imageBasePath + 'man-waving-arm-32' + '.png';
        } else {
            return imageBasePath + 'utility' + utilityId + '.png';
        }
    }

    created(){
        this.$root.$on(PassengerDialog.EVENT_PASSENGER_DIALOG_SHOW, this.onShowPassengerDialog)
    }

    cancelReasonRequired(val: string) {
        return !!val || Vue.i18n.translate('validation.rules.required', 'Required');
    }

    onShowPassengerDialog(passenger: Passenger, data: any){
        this.passenger = passenger;
        if (data){
            this.timetable = data.timetable ? data.timetable : null;
            this.passengerTimetableRides = data.rides ? data.rides : [];
            this.arrivalDeparture = data.arrivalDeparture ? data.arrivalDeparture : null;
        }
        this.show = true;
    }

    async onCancelArrivalDepartureClick(){
        this.sendingArrivalDepartureCancel = true;
        this.arrivalDeparture.cancellationReason = this.cancelreason;
        try {
            await this.$store.dispatch(
                'arrivalDeparture/cancel', 
                { 
                    data: ArrivalDeparture.toApi(this.arrivalDeparture)                   
                }
            );
            this.cancelreason = '';
        } catch {
            vuetifyToast.error(
                this.$i18n.translate(
                    "arrivalDeparture.cancel.error", 
                    "There was an error in sending the cancellation request. Please try again later."
                ),
                {
                    timeout: 25000,
                    dismissible: true
                }
            )
        }
        this.sendingArrivalDepartureCancel = false;
    }

    async onRemovePassengerRidesFromTimetableClick(){
        await this.$store.dispatch(
            'ride/deleteRides', 
            { data: this.passengerTimetableRides.map((r: Ride) => r.id) }
        );
        this.show = false;
    }

    async onRemovePassengerFromTimetableClick(){
        this.timetable.removePassengerIds([this.passenger.id]);
        await this.$store.dispatch(
            'timetable/updateTimetable', 
            { params: { id: this.timetable.id}, data: Timetable.toApi(this.timetable) }
        );
        await this.$store.dispatch(
            'ride/deleteRides', 
            { data: this.passengerTimetableRides.map((r: Ride) => r.id) }
        );
        this.show = false;
    }

    onShowProfileClick(){
        if (this.passenger.passengerDestinations.length > 0) {
            this.$router.push({
                name: Routes.editPeopleRoute.name, 
                params: { 
                    passengerId: this.passenger.id.toString(),
                    destinationId: this.passenger.passengerDestinations[0].destinationId + '', 
                }    
            });
        } else {
            this.$router.push({ 
                name: Routes.passengerRoute.name, 
                params: { 
                    passengerId: this.passenger.id.toString(),
                    destinationId: this.passenger.passengerDestinations[0].destinationId + '', 
                }
            });
        }
        this.show = false;
    }

    beforeDestroy(){       
        this.$root.$off(PassengerDialog.EVENT_PASSENGER_DIALOG_SHOW, this.onShowPassengerDialog)
    }
}

export default PassengerDialog;
